<template>
  <aside
    class="sidebar"
    :class="{ collapsed: isCollapsed }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div class="sidebar-header">
        <div class="logo">
          <img :src="isCollapsed ? require('@/assets/images/mp1.svg') : require('@/assets/images/mp1.svg')" alt="Мир Потолков" />
        </div>
    </div>

    <nav class="sidebar-nav">
      <a
        v-if="hasPermission('view_dashboard')"
        href="#"
        class="nav-item"
        :class="{ active: activeTab === 'dashboard' }"
        @click.prevent="$emit('changeTab', 'dashboard')"
        :title="isCollapsed ? 'Dashboard' : ''"
      >
        <span class="nav-icon">📊</span>
        <span class="nav-text" v-if="!isCollapsed">Dashboard</span>
      </a>

      <a
        v-if="hasPermission('view_hidden')"
        href="#"
        class="nav-item"
        :class="{ active: activeTab === 'hidden' }"
        @click.prevent="$emit('changeTab', 'hidden')"
        :title="isCollapsed ? 'Скрытые заказы' : ''"
      >
        <span class="nav-icon">👁️‍🗨️</span>
        <span class="nav-text" v-if="!isCollapsed">Скрытые заказы</span>
      </a>

      <a
        v-if="hasPermission('view_clients')"
        href="#"
        class="nav-item"
        :class="{ active: activeTab === 'clients' }"
        @click.prevent="$emit('changeTab', 'clients')"
        :title="isCollapsed ? 'Номера клиентов' : ''"
      >
        <span class="nav-icon">📱</span>
        <span class="nav-text" v-if="!isCollapsed">Номера клиентов</span>
      </a>

      <a
        v-if="hasPermission('view_users')"
        href="#"
        class="nav-item"
        :class="{ active: activeTab === 'users' }"
        @click.prevent="$emit('changeTab', 'users')"
        :title="isCollapsed ? 'Пользователи и права' : ''"
      >
        <span class="nav-icon">👥</span>
        <span class="nav-text" v-if="!isCollapsed">Пользователи и права</span>
      </a>

      <a
        v-if="hasPermission('view_settings')"
        href="#"
        class="nav-item"
        :class="{ active: activeTab === 'settings' }"
        @click.prevent="$emit('changeTab', 'settings')"
        :title="isCollapsed ? 'Настройки' : ''"
      >
        <span class="nav-icon">⚙️</span>
        <span class="nav-text" v-if="!isCollapsed">Настройки</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <a
        href="#"
        class="nav-item logout"
        @click.prevent="handleLogout"
        :title="isCollapsed ? 'Выйти' : ''"
      >
        <span class="nav-icon">🚪</span>
        <span class="nav-text" v-if="!isCollapsed">Выйти</span>
      </a>
    </div>
  </aside>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { usePermissions } from '@/composables/usePermissions'

export default {
  name: 'SidebarNav',
  props: {
    activeTab: {
      type: String,
      required: true
    }
  },
  emits: ['changeTab', 'toggleSidebar'],
  setup(props, { emit }) {
    const router = useRouter()
    const { hasPermission, clearPermissions } = usePermissions()
    const isCollapsed = ref(true)

    const handleMouseEnter = () => {
      isCollapsed.value = false
      emit('toggleSidebar', false)
    }

    const handleMouseLeave = () => {
      isCollapsed.value = true
      emit('toggleSidebar', true)
    }

    const handleLogout = () => {
      // Очищаем права пользователя
      clearPermissions()

      // Удаляем данные авторизации
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']

      // Переходим на страницу логина
      router.push('/login')
    }

    return {
      isCollapsed,
      handleMouseEnter,
      handleMouseLeave,
      handleLogout,
      hasPermission
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 260px;
  background: #fff;
  border-right: 1px solid #e5e7eb;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 100;
  transition: width 0.3s ease;
}

.sidebar.collapsed {
  width: 80px;
}

.sidebar-header {
  padding: 10px 10px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.logo img {
  width: 100%;
  max-width:70px;
  object-fit: contain;
  transition: all 0.3s ease;
}

.sidebar.collapsed .logo img {
  max-width: 80px;
}

.sidebar-nav {
  padding: 10px 10px;
}

.sidebar.collapsed .sidebar-nav {
  padding: 10px 10px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  color: #6b7280;
  text-decoration: none;
  border-radius: 10px;
  margin-bottom: 4px;
  font-weight: 500;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
}

.sidebar.collapsed .nav-item {
  padding: 10px;
  justify-content: center;
}

.nav-item:hover {
  background: #f3f4f6;
  color: #1f2937;
}

.nav-item.active {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.nav-icon {
  font-size: 20px;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}

.nav-text {
  flex: 1;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
}

.sidebar-section {
  padding: 20px 15px;
  border-top: 1px solid #e5e7eb;
}

.section-header {
  padding: 0 15px 10px;
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #9ca3af;
  letter-spacing: 0.05em;
}

.nav-item.small {
  padding: 8px 15px;
  font-size: 13px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-dot.cutting {
  background: #f59e0b;
}

.status-dot.harpoon {
  background: #3b82f6;
}

.status-dot.packed {
  background: #10b981;
}

/* FOOTER */
.sidebar-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

.sidebar.collapsed .sidebar-footer {
  padding: 15px 10px;
}

.nav-item.logout {
  margin-bottom: 0;
  background: #fef2f2;
  color: #dc2626;
}

.nav-item.logout:hover {
  background: #fee2e2;
  color: #991b1b;
}

/* RESPONSIVE */
@media (max-width: 1024px) {
  .sidebar:not(.collapsed) {
    width: 200px;
  }
}

@media (max-width: 768px) {
  .sidebar {
    display: none;
  }

  /* На мобильных сворачивание не работает */
  .toggle-btn {
    display: none;
  }
}
</style>